import React from "react";
import "../../../../../assets/styles/main.css";
import "../../../../../assets/styles/responsive.css";

const PrivacyPolicyContent = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <p className="date">Effective Date: December 5, 2024</p>
        <p className="date">Last Updated: December 5, 2024</p>

        <h3>Introduction</h3>
        <p>
          At <strong>LeadBud</strong>, we are committed to protecting your personal information and respecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our platform and services. By accessing or using LeadBud, you agree to the practices described in this policy.
        </p>

        <h3>Information We Collect</h3>

        <h4>1. Personal Information</h4>
        <p>
          When you interact with LeadBud, you may provide personal information, including but not limited to:
        </p>
        <ul>
          <li>Name, email address, and phone number.</li>
          <li>Company name, job title, and industry details.</li>
          <li>Payment information for billing purposes.</li>
        </ul>

        <h4>2. Platform Usage Data</h4>
        <p>
          We automatically collect data about your interaction with our platform, such as:
        </p>
        <ul>
          <li><strong>Technical Information:</strong> Device type, operating system, browser type, IP address, and session duration.</li>
          <li><strong>Behavioral Data:</strong> Pages visited, clicks, and actions taken on the platform.</li>
          <li><strong>Error Logs:</strong> Data related to technical issues for diagnostic purposes.</li>
        </ul>

        <h4>3. Cookies and Tracking Technologies</h4>
        <p>
          We use cookies and similar technologies to enhance your experience, including:
        </p>
        <ul>
          <li>Remembering user preferences.</li>
          <li>Analyzing platform performance and usage.</li>
          <li>Delivering personalized content and recommendations.</li>
        </ul>
        <p>
          You can manage cookies through your browser settings. Note that some features may not function properly without cookies.
        </p>

        <h3>How We Use Your Information</h3>
        <p>LeadBud processes collected data to:</p>
        <ul>
          <li>Provide and personalize our services.</li>
          <li>Improve user experience through analytics and feedback.</li>
          <li>Facilitate secure transactions and subscription management.</li>
          <li>Communicate updates, offers, and changes to services.</li>
          <li>Ensure compliance with legal and regulatory obligations.</li>
        </ul>

        <h3>How We Share Your Data</h3>
        <p>
          We respect your privacy and only share your information in specific circumstances:
        </p>

        <h4>1. Service Providers</h4>
        <p>
          We work with third-party providers for services such as payment processing, data hosting, and customer support. These providers are bound by confidentiality agreements and are prohibited from using your data for purposes beyond what is specified.
        </p>

        <h4>2. Legal Obligations</h4>
        <p>
          We may disclose your data to comply with applicable laws and regulations, respond to legal processes, or protect our rights and safety.
        </p>

        <h4>3. Business Transfers</h4>
        <p>
          In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction. You will be notified of such changes.
        </p>

        <h3>Your Rights Under GDPR and CCPA</h3>

        <h4>1. GDPR Rights for EU Users</h4>
        <ul>
          <li><strong>Access:</strong> Request a copy of your data.</li>
          <li><strong>Correction:</strong> Update incorrect or incomplete information.</li>
          <li><strong>Erasure:</strong> Request deletion of your personal data.</li>
          <li><strong>Restriction:</strong> Limit the processing of your data.</li>
          <li><strong>Portability:</strong> Receive your data in a structured, machine-readable format.</li>
          <li><strong>Objection:</strong> Object to the processing of your data for specific purposes.</li>
        </ul>

        <h4>2. CCPA Rights for California Users</h4>
        <ul>
          <li><strong>Access:</strong> Know what personal data we collect and how it is used.</li>
          <li><strong>Delete:</strong> Request deletion of your personal information.</li>
          <li><strong>Opt-Out:</strong> Decline the sale of your personal information.</li>
          <li><strong>Non-Discrimination:</strong> Receive equal service and pricing, even if you exercise your privacy rights.</li>
        </ul>
        <p>
          To exercise these rights, contact us at <a href="mailto:info@leadbud.io">info@leadbud.io</a>.
        </p>

        <h3>Retention of Data</h3>
        <p>
          We retain your information as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, or resolve disputes. When data is no longer needed, it is securely deleted.
        </p>

        <h3>Data Security</h3>
        <p>
          We implement strict security measures, including encryption, access control, and regular audits, to protect your information. While we strive to safeguard your data, no system is completely secure. By using LeadBud, you acknowledge and accept potential risks.
        </p>

        <h3>International Data Transfers</h3>
        <p>
          For users outside the United States, your data may be transferred and processed in the United States or other countries. LeadBud ensures compliance with applicable data protection regulations for such transfers.
        </p>

        <h3>Cookies Policy</h3>
        <p>
          We use cookies to enhance your experience, analyze platform performance, and provide personalized content. You can manage your preferences through browser settings. For more details, refer to our <a href="https://leadbud.io/cookie-policy">Cookie Policy</a>.
        </p>

        <h3>Changes to This Privacy Policy</h3>
        <p>
          This Privacy Policy may be updated periodically to reflect changes in our practices or for compliance with legal and regulatory requirements. Updates will be posted on this page, and significant changes will be communicated via email or platform notifications.
        </p>

        <h3>Contact Us</h3>
        <p>
          If you have questions or concerns about this Privacy Policy, please contact us:
        </p>
        <p><strong>Email:</strong> <a href="mailto:info@leadbud.io">info@leadbud.io</a></p>
        <p><strong>Address:</strong> LeadBud</p>
        <p>
          Thank you for trusting LeadBud. Your privacy is our priority.  
          <strong>Let’s grow your business together!</strong>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent;
